import { useState } from 'react';
import { Input } from '@didi-pebble/pebble-design-react';

const { Search } = Input;

const SearchComp = ({ ...props }: any) => {
  const { style, placeholder, allowClear, getValueFromEvent, size, value = '', onChange } = props;
  const [searchValue, setSearchValue] = useState<string>(value);

  return (
    <Search
      value={searchValue}
      placeholder={placeholder} // 'Applied person/email'
      allowClear={allowClear}
      onChange={e => {
        const eValue = getValueFromEvent(e);

        setSearchValue(eValue);
      }}
      onSearch={(val: string) => {
        setSearchValue(val);
        onChange?.(val);
      }}
      style={style}
      autoComplete='off'
      size={size}
    />
  );
};

export default SearchComp;
